import { RoomNumber } from './index';
import { DashboardAccommodationType } from './dashboard-accommodation.model';

export class OccupiedAccommodation {

    constructor(propertyAccommodationType, occupancy, ...params) {

        if (!(propertyAccommodationType instanceof DashboardAccommodationType)) {

            throw new Error(`Invalid arguments type. Expected (DashboardAccommodationType). Given ${typeof propertyAccommodationType}`);
        }

        this.accommodation = propertyAccommodationType;
        this.occupancy = occupancy;

        this.options = params;
    }

    static build({accommodation, occupancy}) {

        accommodation.room_numbers = accommodation.room_numbers.map(room => {
            room.current_accommodation = accommodation;
            return new RoomNumber(room);
        });

        return new OccupiedAccommodation(new DashboardAccommodationType(accommodation), occupancy);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/models/ocuppied-accommodation.model.js